import { useState, useEffect } from 'react';
import { Column } from 'primereact/column';
import { DataSource } from 'components/DataSource';
import { DataTable } from 'primereact/datatable';
import { Dropdown } from 'primereact/dropdown';
import { ProgressBar } from 'primereact/progressbar';

import { Tag } from "primereact/tag";
import axios from "axios";
export default function EmicollectionstatusPage() {
	
	const [pageReady, setPageReady] = useState(true);
	const [data, setData] = useState([]);
const [loading, setLoading] = useState(false);
const [userid, setuserid] = useState(null);
useEffect(() => {
    if (userid) {
        loadData(userid);
    }
}, [userid]);
const loadData = async (userid) => {
    setLoading(true);
    try {
        const res = await axios.get("/Components_Data/emi_status", {
            params: { userid }   // 👈 passes ?userid=123
        });
        setData(res.data);
        } catch (err) {
        console.error(err);
        } finally {
        setLoading(false);
    }
};
    // =========================================================
    // TEXT
    // =========================================================
    const textTemplate = (value) => {
        if (
            value === null ||
            value === undefined ||
            value === ""
        ) {
            return "-";
        }
        return String(value).trim();
    };
    // =========================================================
    // CURRENCY
    // =========================================================
    const currencyTemplate = (row, field) => {
        const amount = Number(
            row?.[field] ?? 0
        );
        if (!Number.isFinite(amount)) {
            return "₹0.00";
        }
        return (
            <span className="font-semibold">
                ₹
                {amount.toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })}
            </span>
        );
    };
    // =========================================================
    // DATE
    // =========================================================
    const dateTemplate = (row) => {
        if (!row?.paydate) {
            return "-";
        }
        const date = new Date(row.paydate);
        if (Number.isNaN(date.getTime())) {
            return "-";
        }
        return date.toLocaleDateString(
            "en-GB",
            {
                day: "2-digit",
                month: "2-digit",
                year: "numeric"
            }
        );
    };
    // =========================================================
    // EMI STATUS
    // =========================================================
    const statusTemplate = (row) => {
        const status = String(
            row?.emiStatus ?? ""
        )
            .trim()
            .toUpperCase();
        let severity = "info";
        switch (status) {
            case "COLLECTED":
                severity = "success";
                break;
            case "OVERDUE":
                severity = "danger";
                break;
            case "DUE TODAY":
                severity = "warning";
                break;
            case "PARTIAL":
                severity = "warning";
                break;
            case "FUTURE":
                severity = "info";
                break;
            default:
                severity = "secondary";
                break;
        }
        return (
            <Tag
                value={status || "UNKNOWN"}
                severity={severity}
            />
        );
    };
    // =========================================================
    // OVERDUE DAYS
    // =========================================================
    const overdueTemplate = (row) => {
        const days = Number(
            row?.overdueDays ?? 0
        );
        if (!Number.isFinite(days)) {
            return "-";
        }
        if (days <= 0) {
            return "0";
        }
        return (
            <span className="text-red-500 font-bold">
                {days.toLocaleString("en-IN")}
            </span>
        );
    };
    // =========================================================
    // DPD BUCKET
    // =========================================================
    const dpdTemplate = (row) => {
        const bucket = String(
            row?.dpD_Bucket ?? ""
        ).trim();
        if (!bucket) {
            return "-";
        }
        let severity = "info";
        switch (bucket) {
            case "CURRENT":
                severity = "success";
                break;
            case "01-30":
                severity = "warning";
                break;
            case "31-60":
                severity = "warning";
                break;
            case "61-90":
                severity = "danger";
                break;
            case "90+":
                severity = "danger";
                break;
            default:
                severity = "info";
                break;
        }
        return (
            <Tag
                value={bucket}
                severity={severity}
            />
        );
    };
	return (
		<main id="EmicollectionstatusPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <div className="">
                    <DataSource   apiPath="components_data/get_users"  >
                        {({ response }) => {
                        const dropdownOptions = response?.map(x => ({
                        label: x.username || x.label, // adjust field
                        value: x.userid || x.value
                        })) || [];
                        return (
                        <>
                        <Dropdown
                        name="userid"
                        value={userid}
                        onChange={(e) => setuserid(e.value)}
                        options={dropdownOptions}
                        optionLabel="label"
                        optionValue="value"
                        filter   // 🔍 enables search box
                        showClear
                        placeholder="Select a User"
                        className="w-500"
                        />
                        </>
                        );
                        }}
                    </DataSource>
                </div>
                <div className="">
                    <div className="card">
                        {/* =========================================
                        HEADER
                        ========================================= */}
                        <div
                            className="
                            flex
                            justify-content-between
                            align-items-center
                            mb-3
                            "
                            >
                            <h3 className="m-0">
                            EMI Collection Status
                            </h3>
                            <span className="text-500">
                            Total Records:{" "}
                            <strong>
                            {data.length}
                            </strong>
                            </span>
                        </div>
                        {/* =========================================
                        LOADING
                        ========================================= */}
                        {loading && (
                        <ProgressBar
                        mode="indeterminate"
                        style={{
                        height: "4px",
                        marginBottom: "8px"
                        }}
                        />
                        )}
                        {/* =========================================
                        DATA TABLE
                        ========================================= */}
                        <DataTable
                            value={data}
                            paginator
                            rows={15}
                            rowsPerPageOptions={[
                            10,
                            15,
                            25,
                            50,
                            100
                            ]}
                            loading={loading}
                            responsiveLayout="scroll"
                            showGridlines
                            stripedRows
                            filterDisplay="row"
                            emptyMessage="No EMI records found"
                            removableSort
                            sortMode="multiple"
                            >
                            {/* =====================================
                            BRANCH
                            ===================================== */}
                            <Column
                                field="branchcode"
                                header="Branch"
                                body={(row) =>
                                textTemplate(
                                row.branchcode
                                )
                                }
                                filter
                                sortable
                                />
                                {/* =====================================
                                GROUP
                                ===================================== */}
                                <Column
                                    field="groupid"
                                    header="Group"
                                    body={(row) =>
                                    textTemplate(
                                    row.groupid
                                    )
                                    }
                                    filter
                                    sortable
                                    />
                                    {/* =====================================
                                    MEMBER
                                    ===================================== */}
                                    <Column
                                        field="memberid"
                                        header="Member"
                                        body={(row) =>
                                        textTemplate(
                                        row.memberid
                                        )
                                        }
                                        filter
                                        sortable
                                        />
                                        <Column
                                            field="membername"
                                            header="Name"
                                            body={(row) =>
                                            textTemplate(
                                            row.membername
                                            )
                                            }
                                            filter
                                            sortable
                                            />
                                            {/* =====================================
                                            LOAN ACCOUNT
                                            ===================================== */}
                                            <Column
                                                field="loanaccountno"
                                                header="Loan A/c No"
                                                body={(row) =>
                                                textTemplate(
                                                row.loanaccountno
                                                )
                                                }
                                                filter
                                                sortable
                                                />
                                                {/* =====================================
                                                EMI NUMBER
                                                ===================================== */}
                                                <Column
                                                    field="period"
                                                    header="EMI #"
                                                    sortable
                                                    style={{
                                                    width: "80px",
                                                    textAlign: "center"
                                                    }}
                                                    />
                                                    {/* =====================================
                                                    DUE DATE
                                                    ===================================== */}
                                                    <Column
                                                        field="paydate"
                                                        header="Due Date"
                                                        body={dateTemplate}
                                                        sortable
                                                        />
                                                        {/* =====================================
                                                        EMI AMOUNT
                                                        ===================================== */}
                                                        <Column
                                                            field="emiamount"
                                                            header="EMI Amount"
                                                            body={(row) =>
                                                            currencyTemplate(
                                                            row,
                                                            "emiamount"
                                                            )
                                                            }
                                                            sortable
                                                            style={{
                                                            textAlign: "right"
                                                            }}
                                                            />
                                                            {/* =====================================
                                                            COLLECTED AMOUNT
                                                            ===================================== */}
                                                            <Column
                                                                field="collectedAmount"
                                                                header="Collected"
                                                                body={(row) =>
                                                                currencyTemplate(
                                                                row,
                                                                "collectedAmount"
                                                                )
                                                                }
                                                                sortable
                                                                style={{
                                                                textAlign: "right"
                                                                }}
                                                                />
                                                                {/* =====================================
                                                                EMI STATUS
                                                                ===================================== */}
                                                                <Column
                                                                    field="emiStatus"
                                                                    header="Status"
                                                                    body={statusTemplate}
                                                                    filter
                                                                    sortable
                                                                    />
                                                                    {/* =====================================
                                                                    OVERDUE DAYS
                                                                    ===================================== */}
                                                                    <Column
                                                                        field="overdueDays"
                                                                        header="OD Days"
                                                                        body={overdueTemplate}
                                                                        sortable
                                                                        style={{
                                                                        width: "100px",
                                                                        textAlign: "center"
                                                                        }}
                                                                        />
                                                                        {/* =====================================
                                                                        DPD BUCKET
                                                                        ===================================== */}
                                                                        <Column
                                                                            field="dpD_Bucket"
                                                                            header="DPD Bucket"
                                                                            body={dpdTemplate}
                                                                            filter
                                                                            sortable
                                                                            style={{
                                                                            width: "120px",
                                                                            textAlign: "center"
                                                                            }}
                                                                            />
                                                                        </DataTable>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </section>
		</main>
	);
}
